
import academicConsole from './views/academicConsole.html';
import batchSliderTemplate from './views/batch-slider.html';
import subjectTemplate from './views/add-subject.html';
import './wizard.scss'

import wizardStatus from './wizard';

const name = 'academicConsole';

class AcademicConsoleCtrl {
    constructor($scope,  $stateParams, $rootScope, $state, $mdDialog, $mdMedia, 
        localStorageService, authService) {
        'ngInject';
        var localSchoolId = localStorageService.get('school_id')
        var localMyUserId = localStorageService.get('user_id')
        $rootScope.title = "Academic Console"
        let self = this;
        $scope.subjecttitle = '';
        $scope.currentCurriculum = '';
        this.sessionIds = []
        this.batchLists = {}
        self.enableNextBtn = false;
        self.enableSlider = false;
        var classArry = []
        var batchesArry = []
        $scope.activeBtn = [];
        $scope.showWizard = false;

        let subsAcademicPack = undefined,
            subsSetting = undefined,
            subsSession = undefined;
        self.methodAfterBatchUpdate = () => {
            let send = {
                school_id : localStorageService.get('school_id')
            }
            authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", 
            {args : send}, function (response) {
                try{
                    if(!response.error){
                        autorun(response.result.data.data)
                        getAcademics(response.result.data.data)
                    }else{
                    }
                }catch(e){
                    console.log(e)
                }
            })
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Academic Console"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            // subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
            let send = {
                school_id : localStorageService.get('school_id')
            }
            authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", 
            {args : send}, function (response) {
                try{
                    if(!response.error){
                        autorun(response.result.data.data)
                        getAcademics(response.result.data.data)
                    }else{
                    }
                }catch(e){
                    console.log(e)
                }
                _.defer(function() {
                    $scope.$apply()
                })
            })
        }

        this.$onDestroy = () => {
            if (subsAcademicPack)
                subsAcademicPack.stop()
            if (subsSetting)
                subsSetting.stop()
            if (subsSession)
                subsSession.stop()

            self.sessionpackage = undefined
            self.sessionCurriArray = undefined
            self.batchLists = undefined
        }

        $scope.getBatchString = (list) => {
            return _.pluck(list, 'name').join(",")
        }


        $scope.btnLabel = "Save"
        let send = {
            userId : localMyUserId,
            schoolId : localSchoolId}
        authService.callAPI("/v0/initial-settings/user-console/getUserPrivilageInitialSetting", "POST", 
        send, function (response) {
            try{
                if(!response.error){
                    self.checkintialSettingValue(response.result.data.data.initial_settings)
                }else{
                }
            }catch(e){
                console.log(e)
            }
        })
        // self.call('getUserPrivilageInitialSetting', Meteor.userId(), Session.get('school_id'), (error, result) => {
        //     if (result) {
        //         self.checkintialSettingValue(result.initial_settings)
        //     }
        // })

        self.checkintialSettingValue = function(val) {
            $scope.tabStats = {}
            for (var i = 1; i <= 5; i++) {
                if (i <= val) {
                    $("#prop" + i).removeClass('disabled');
                } else {
                    $scope.tabStats['tab' + i] = "disabled";
                }
            };
            if (val < 5) {
                $scope.btnLabel = "Next"
                $scope.showWizard = true;
            } else {
                if (val === 5) {

                    $scope.hideNextButtonAcademicConsole = true
                }
            }
        }

        let getAcademics = (response) => {

            /***session***/
            let settings = response.sett
            let alreadyAddedSessions = self.sessionIds
            self.sessionpackage = _.find(settings, function(one){
                return one.type == "session"
            })
            if (self.sessionpackage) {
                self.sessionpackage.list = _.filter(self.sessionpackage.list, function(sess) {
                    return alreadyAddedSessions.indexOf(sess._id) !== -1
                })
            }
            self.batchPackage = _.find(settings, function(one){
                return one.type == "batch"
            })
            self.classpackage = _.find(settings, function(one){
                return one.type == "class"
            })
            classArry = _.pluck(self.classpackage.list, "name")
            batchesArry = _.pluck(self.batchPackage.list, "name")
            $scope.setClassSlider()
            if (self.sessionpackage.list.length <= 0) {
                toastr.error("Please add the session and curriculum");
                return false;
            }
            let firstSession = self.sessionpackage.list[0]
            this.showThis(firstSession._id, firstSession.name)
            if (self.sessionpackage && self.sessionpackage.list) {
                let sessionArray = _.uniq(self.sessionpackage.list, function(doc) {
                    return doc._id
                });
                self.sessionpackage.list = sessionArray
            }

        }

        $scope.setClassSlider = () => {

            let startRange = 0
            let endRange = 0
            if (Object.keys(self.batchLists).length > 0) {
                let currentXclassesIndex = $scope.selectedSession + "_" + $scope.currentCurriculum

                if (self.batchLists[currentXclassesIndex] && self.batchLists[currentXclassesIndex].length > 0) {
                    startRange = self.batchLists[currentXclassesIndex][0].name
                    let xclassesLen = self.batchLists[currentXclassesIndex].length
                    endRange = self.batchLists[currentXclassesIndex][xclassesLen - 1].name
                }
            }
            $scope.range_slider_ticks_values = { //class slider
                startRange: startRange,
                endRange: endRange,
                options: {
                    stepsArray: classArry,
                    getSelectionBarColor: function(v) {
                        return '#1AA762';
                    },
                    showTicksValues: true,
                    //showSelectionBar: true,
                    ticksValuesTooltip: function(v) {
                        var classe = classArry[v];
                        return 'Class -' + classe;
                    }
                }
            }
            setTimeout(function() {
                $scope.$broadcast('reCalcViewDimensions');
            }, 500)

        }

        self.setBatchList = (type, cid) => {
            let acadCurriculum = _.find($scope.acdConsoles, function(one){
                return one.session_id == type && one.curriculum_id == cid
            })
            let xclasses = []
            if (acadCurriculum) {
                let batchMap = {}
                _.each(acadCurriculum.xclass, function(xclass) {
                    let obj = {}

                    obj._id = xclass._id

                    obj.name = _.find(self.classpackage.list, function(clasSetting) {
                        return clasSetting._id == xclass._id
                    }).name
                    obj.xclassIndex = classArry.indexOf(obj.name)
                    let myBatches = []
                    _.each(xclass.batches, function(batch) {
                        if (!batchMap[batch]) {
                            batchMap[batch] = _.find(self.batchPackage.list, function(batchSetting) {
                                return batchSetting._id == batch
                            })
                        }
                        myBatches.push(batchMap[batch])
                    })
                    obj.batches = myBatches
                    xclasses.push(obj)
                })

                if (xclasses && xclasses.length > 0) {
                    self.batchLists[cid + "_" + type] = xclasses

                }

            }
        }

        self.showCurriculum = function(curriculum, cid, tabName, index, item, type, parentIndex) {

            self.setBatchList(type, cid)
            
            $scope.selected = item;
            let selectedSession = $scope.currentCurriculum;

            $scope.selectedSession = cid;

            $scope.setClassSlider()
            $scope.subjecttitle = cid; //passing curriculum id to add-subject-component.js page (saveSubjectArry)
            self.enableSlider = self.enableSlider === false ? true : false;
            let sid = $scope.currentCurriculum;
            let dataArray = _.filter($scope.acdConsoles, function(one){
                return one.session_id == sid
            })
            let statusOfClass = false;
            _.each(dataArray, function(eachVal) {
                if (eachVal.curriculum_id === cid) {
                    statusOfClass = true;
                }
            })
            if (statusOfClass === true) {
                $scope.activeBtn[index] = true
            } else {
                $scope.activeBtn[index] = false
            }
            for (var i = 0; i < $scope.activeBtn.length; i++) {
                if (i == index) {
                    $scope.activeBtn[index] = true
                    self.enableSlider = true;
                } else {
                    $scope.activeBtn[i] = false
                }
            }
        }

        self.showThis = function(setId, tab) {
            self.enableSlider = false;

            for (var i = 0; i < $scope.activeBtn.length; i++) {
                $scope.activeBtn[i] = false // To make all curriculum as false
            }
            $scope.currentCurriculum = setId; //passing curriculum id to add-subject-component.js page(saveSubjectArry)
            let sessionsListArry = [];
            self.sessionCurriArray = []
            self.enableNextBtn = true;
            let curId = _.filter($scope.acdConsoles, function(one){
                return one.session_id == setId
            })
            _.each(curId, function(currList) {
                sessionsListArry.push(currList.curriculum_id);
            })
            self.sessionsListArry = _.uniq(sessionsListArry)
            _.each(self.sessionsListArry, function(id) {
                let cName = self.getCurName(id)

                self.sessionCurriArray.push({
                    id: id,
                    cName: cName
                })
            })
            let curriculumBtn = self.sessionCurriArray[0]
            self.showCurriculum(curriculumBtn.cName, curriculumBtn.id, 1, 0, curriculumBtn, setId, 0)
        }
        self.getCurName = function(id) {
            let fullName = '';
            self.curDetails = _.filter($scope.sett, function(one){
                return one.type == "curriculum"
            })
            _.each(self.curDetails[0].list, function(lid) {
                if (lid._id === id) {
                    fullName = (lid.name);
                }
            })
            return fullName;
        }
        self.getSession = function() {
            let send = {
                school_id : localStorageService.get('school_id')
            }
            authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", 
            {args : send}, function (response) {
                try{
                    if(!response.error){
                        autorun(response.result.data.data)
                        getAcademics(response.result.data.data)
                    }else{
                    }
                }catch(e){
                    console.log(e)
                }
            })
            // subsSession = self.subscribe('getSessionPackage', () => [], {
            //     onReady: function() {
            //         self.autorun(() => {
            //             self.curriculumList = [];
            //             let sessionIds = AcademicConsole.find({ school_id: Session.get('school_id') }).fetch();

            //             if (sessionIds && sessionIds.length && sessionIds.length > 0) {
            //                 self.sessionIds = _.uniq(_.pluck(sessionIds, 'session_id'))
            //             }
            //         })
            //         getAcademics()
            //     }
            // });
        }
        // self.getSession()
            /*--------------------------------------*/

        // this.autorun(() => {
        //     var sessionsAry = [];
        //     var curiculAry = [];
        //     let sessIds = AcademicConsole.find({ school_id: Session.get('school_id') }).fetch();
        //     _.each(sessIds, function(data1) {
        //         sessionsAry.push(data1.session_id);
        //         curiculAry.push(data1.curriculum_id);
        //     })

        //     self.sessIds = _.uniq(sessionsAry);
        //     self.curiIds = curiculAry;
        // })
        function autorun(response){
            var sessionsAry = [];
            var curiculAry = [];
            $scope.acdConsoles = response.acConsoles
            $scope.sett = response.sett
            let sessIds = response.acConsoles
            _.each(sessIds, function(data1) {
                sessionsAry.push(data1.session_id);
                curiculAry.push(data1.curriculum_id);
            })

            self.sessIds = _.uniq(sessionsAry);
            self.curiIds = curiculAry;
            self.curriculumList = [];
            let sessionIds = response.acConsoles

            if (sessionIds && sessionIds.length && sessionIds.length > 0) {
                self.sessionIds = _.uniq(_.pluck(sessionIds, 'session_id'))
            }
        }
        var alpha = [];
        var batch = [];
        for (var i = 65; i <= 90; i++) {
            alpha.push(String.fromCharCode(i));
        }
        for (var i = 65; i <= 90; i++) {
            var first = 'A';
            var next = String.fromCharCode(i);
            alpha.push(first + next);
        }
        $scope.getTotalDivision = function(s, e) {
            var s = $scope.getTotalClass(e, s, 'batchList')
            return s;
        }
        $scope.alphabetTranslate = function(value) {
            if (isNaN(value) || value == undefined) {

            } else {
                return alpha[value].toUpperCase();
            }
        };
        $scope.getClassName = function(value) {
            return classArry[value];
        };
        //Slider 1 for class range,listing from classArry.

        /***************************************************************/
        var startClass, endClass, batchStart, batchEnd;
        $scope.$on('slideEnded', function() {
            setRanges()
        });

        function setRanges() {
            startClass = classArry.indexOf($scope.range_slider_ticks_values.startRange);
            startClass++;
            endClass = classArry.indexOf($scope.range_slider_ticks_values.endRange);
            endClass++
        }

        this.showClass = function(s, e) {
            setRanges();
            // s = classArry.indexOf( e )

            let st = classArry.indexOf(s);
            let eachClassID = [];
            let selectedArry = [];
            var myClasses = self.classpackage.list.slice(st, classArry.indexOf(e) + 1);
            let selectedCurriculum = $scope.currentCurriculum;
            let selectedSession = $scope.selectedSession;
            selectedArry.push($scope.currentCurriculum)
            selectedArry.push($scope.selectedSession)

            _.each(myClasses, function(classes) {
                eachClassID.push(classes._id)
                // addClasses(selectedSession, selectedCurriculum, classes._id)
            })
            let send = {
                school_id : localStorageService.get('school_id'),
                curiId : selectedSession,
                sessId : selectedCurriculum,
                classId : myClasses,
                myUserId : localStorageService.get('user_id')
            }
            authService.callAPI("/v0/initial-settings/academic-console/addClassPackage", "POST", 
            {args : send}, function (response) {
                try{
                    if(!response.error){
                        console.log(response)
                    }else{
                    }
                }catch(e){
                    console.log(e)
                }
            })
            // return false
            let batchSlide = [{
                "startRange": startClass,
                "endRange": endClass
            }];

            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: [ '$scope', '$mdDialog', 'data', 'classIds', 
                'selected', 'allBatches', 'addedBatches', 'parentCtrl', 'classArry',
                 'batchesArry', 'localStorageService', 'authService', DialogController],
                controllerAs: 'batchesCtrls',
                locals: {
                    "data": batchSlide,
                    "classIds": eachClassID,
                    "selected": selectedArry,
                    "allBatches": self.batchPackage.list,
                    "addedBatches": self.batchLists,
                    "parentCtrl": self,
                    "classArry": classArry,
                    'batchesArry': batchesArry,
                    'localStorageService' : localStorageService,
                    'authService' : authService
                },
                template: batchSliderTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: useFullScreen
            })
            $scope.$watch(function() {
                return $mdMedia('xs') || $mdMedia('sm');
            }, function(wantsFullScreen) {
                $scope.customFullscreen = (wantsFullScreen === true);
            });
        };

        // function addClasses(selectedSession, selectedCurriculum, cid) {
        //     Meteor.call("addClassPackage", selectedSession, selectedCurriculum, cid);
        // }

        this.goNext = function() {

            if ($scope.btnLabel === "Next") {
                Meteor.call("updateInitialSettingValue", 3, function(error, result) {
                    toastr.success("Successfully saved!");
                    $state.go("userConsole")
                });

            } else {
                toastr.success("Updated successfully!");
                $state.go("initialSetting")
            }
        }

    }
}

class DialogController {
    constructor($scope, $mdDialog, data, classIds, selected, 
        allBatches, addedBatches, parentCtrl, classArry, batchesArry,
         localStorageService, authService) {
        'ngInject';


        $scope.loading = false;
        let addedXclasses = []
        let batchKey = selected[1] + "_" + selected[0]
        if (addedBatches && addedBatches[batchKey] && Object.keys(addedBatches[batchKey]).length > 0) {
            addedXclasses = addedBatches[selected[1] + "_" + selected[0]]

            $scope.editMode = true
        }
        $scope.batchSliders = data;
        $scope.batchSlidersClassid = classIds;
        $scope.selectedDetails = selected;
        $scope.allBatchesDetails = allBatches;
        var startClass = $scope.batchSliders[0].startRange;
        var endClass = $scope.batchSliders[0].endRange;


        var alpha = [];
        var batch = [];
        for (var i = 65; i <= 90; i++) {
            alpha.push(String.fromCharCode(i));
        }
        for (var i = 65; i <= 90; i++) {
            var first = 'A';
            var next = String.fromCharCode(i);
            alpha.push(first + next);
        }
        $scope.getTotalDivision = function(s, e) {
            var s = $scope.getTotalClass(e, s, 'batchList')
            return s;
        }

        $scope.alphabetTranslate = function(value) {
            if (isNaN(value) || value == undefined) {

            } else {
                return alpha[value].toUpperCase();
            }
        };

        $scope.$on('slideEnded', function() {

        });

        $scope.hide = function() {
            $mdDialog.hide();
        };
        let numberTranslate = function(value) {
            return alpha.indexOf(value);
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        $scope.answer = function(answer) {
            $mdDialog.hide(answer);
        };
        $scope.getTotalClass = function(highEnd, lowEnd, mode) {
            var list = [];
            for (var i = lowEnd; i <= highEnd; i++) {
                list.push(i);
            }
            if (mode === 'sliderCount') {
                return list.length;
            }
            if (mode === 'batchList') {
                return list;
            }
        }
        $scope.getBatchSliders = function(startClass, endClass) {
            endClass = parseInt(endClass);
            var totalSlider;
            if (startClass === 1 || startClass === 2) {
                startClass = startClass;
                endClass = endClass;
            }
            if (startClass >= 3) {
                startClass = startClass - 2;
                endClass = endClass - 2;
            }
            return [{
                'startClass': startClass,
                'endClass': endClass
            }]
        }

        let bslider = $scope.getBatchSliders(startClass, endClass);

        if (bslider !== {}) {
            let lastBatch = bslider[0].endClass;
            let firstBatch = bslider[0].startClass;
            $scope.totalSliders = $scope.getTotalClass(lastBatch, firstBatch, 'sliderCount');
        }

        $scope.getNumber = function(num, startClass, endClass) {
            var batch = [];
            $scope.batchNames = $scope.getTotalClass(endClass, startClass, 'batchList');
            var arrayLength = $scope.batchNames.length;
            for (var i = 0; i < arrayLength; i++) {
                var txt = $scope.batchNames[i] - 1;
                batch.push(classArry[txt]);
            }

            $scope.batch = unique(batch);

            return new Array(num);
        }

        $scope.addJs = ($index) => {
            if (!$scope.range_slider_batch_values) {
                $scope.range_slider_batch_values = []
            }
            let startRange = 0
            let endrange = 2
            if ($scope.editMode) {
                let xclass = _.find(addedXclasses, function(batchIn) {
                    return batchIn.name == $scope.batch[$index]
                })
                if (xclass && xclass.batches && xclass.batches.length > 0) {

                    startRange = xclass.batches[0].name
                    endrange = xclass.batches[xclass.batches.length - 1].name

                }
            }
            $scope.range_slider_batch_values[$index] = {
                startRange: startRange,
                endRange: endrange,
                options: {
                    stepsArray: batchesArry,
                    onEnd: function() {},
                    //showTicksValues: true,
                    showSelectionBar: true,
                    getSelectionBarColor: function(v) {
                        return '#1AA762';
                    },
                    ticksValuesTooltip: function(v) {
                        var bach = alpha[v];
                        return 'Division -' + bach;
                    }
                }
            }
            setTimeout(function() {
                $scope.$broadcast('reCalcViewDimensions');
            }, 500)
        }

        var unique = function(origArr) {
            var newArr = [],
                origLen = origArr.length,
                found, x, y;
            for (x = 0; x < origLen; x++) {
                found = undefined;
                for (y = 0; y < newArr.length; y++) {
                    if (origArr[x] === newArr[y]) {
                        found = true;
                        break;
                    }
                }
                if (!found)
                    newArr.push(origArr[x]);
            }
            return newArr;
        }

        function addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails) {
            let bths = be + 1;
            let send = {
                seleArrys : seleArrys,
                clsIDs : batchSlidersClassid,
                allBatchDetails : allBatchesDetails,
                starts : bs,
                ends : be,
                classArry : alpha,
                school_id : localStorageService.get('school_id'),
                myUserId : localStorageService.get('user_id')
            }
            // console.log(send)
            authService.callAPI("/v0/initial-settings/addBatchesArry", "POST", 
                {args : send}, function (response) {
                    try{
                        console.log('sendsendsendsend')
                        if(!response.error){
                        let result = response.result.data
                        
                        parentCtrl.setBatchList(seleArrys[0], seleArrys[1])
                        toastr.success("Batches added for class " + c);
                        $scope.loading = false;
                        $mdDialog.hide();
                        
                        parentCtrl.methodAfterBatchUpdate()
                    }else{
                        $scope.loading = false;
                        toastr.error("Network error");
                    }
                }catch(e){
                    console.log(e)
                }
            })
        }

        $scope.addAllBatch = function(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails) {

            // $scope.loading = true;
            if (parentCtrl.initialSettingId < 5) {
                // seleArrys, clsIDs, allBatchDetails, starts, ends, classArry, school_id
                
                addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails)
            } else {
                let send = {
                    seleArrys : seleArrys,
                    clsIDs : batchSlidersClassid,
                    allBatchDetails : allBatchesDetails,
                    starts : bs,
                    ends : be,
                    classArry : alpha,
                    school_id : localStorageService.get('school_id'),
                    muUserId : localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/initial-settings/academicConsolesWithSchool", "POST", 
                {args : send}, function (response) {
                    try{
                        console.log(response)
                        if(!response.error){
                            let res = response.result.data.details
                            console.log(res)
                            if (res.classAvailable != undefined) {
                                $scope.loading = false;
                                toastr.error(res.classAvailable);
                                _.defer(function() { $scope.$apply(); });;
                                return false;
                            } else {
                                addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails)
                            }
                        }else{
                        }
                    }catch(e){
                        console.log(e)
                    }
                })
                // Meteor.call("fetchAcademicConeForCheck", seleArrys, batchSlidersClassid, allBatchesDetails, bs, be, alpha, Session.get('school_id'), function(err, res) {
                //         if (err) {
                //             $scope.loading = false;
                //             toastr.success(err.reason);
                //         } else {

                //             if (res.classAvailable != undefined) {
                //                 $scope.loading = false;
                //                 toastr.error(res.classAvailable);
                //                 _.defer(function() { $scope.$apply(); });;
                //                 return false;
                //             } else {
                //                 addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails)
                //             }
                //             // if (res.totalError) { //error comes here if result is not zero
                //             //     toastr.error("Cannot delete already added classes or batches");
                //             //     return false
                //             // } 
                //         }
                //     })
                    // }
            }

            // $scope.addBatch_NEW = function(a, b, c, allBatchesDetails, clsID) {

            //     let batchValues = $scope.range_slider_batch_values;
            //     _.each(batchValues, function(val) {

            //         let bths = val.endRange + 1;

            //         var myBatches = allBatchesDetails.slice(val.startRange, bths);

            //         let start = $scope.alphabetTranslate(val.startRange)
            //         let end = $scope.alphabetTranslate(val.endRange)

            //     })

            // }
            $scope.alphabetTranslate = function(value) {
                if (isNaN(value) || value == undefined) {

                } else {
                    return alpha[value].toUpperCase();
                }
            };
        }
    }

}

class AddSubject {
    constructor($scope,  $stateParams, $rootScope, $state, $mdDialog, $mdMedia, localStorageService, authService) {

        let self = this;
        let setSubjects = () => {

            self.selectBucket = [];
            self.packagesToAdd = [];
            self.subjectPackage = [];

            self.subjectPackage = _.filter($scope.sett, function(one){
                return one.type == "subject"
            })
            self.packagesToAdd = _.filter(angular.copy($scope.sett), function(one){
                return one.type == "subject"
            })
            
            let selectedsubjIds = _.find($scope.acdConsoles, function(one){
                return one.session_id == $scope.sessionId && one.curriculum_id == $scope.cirriculumId
            })


            if (!selectedsubjIds && self.subjectPackage.length <= 0) {
                return false
            }

            let packageIds = _.pluck(selectedsubjIds.subject_package, "_id")
            let subjects = _.flatten(_.pluck(selectedsubjIds.subject_package, "subjects"))
            
            for (var i = 0; i < self.subjectPackage.length; i++) {
                
                if (packageIds.indexOf(self.subjectPackage[i]._id) != -1) {
                    
                    let subject = _.filter(self.subjectPackage[i].list, (item) => {
                        return subjects.indexOf(item._id) !== -1
                    })
                    self.packagesToAdd[i].list = _.filter(self.packagesToAdd[i].list, (item) => {
                        return subjects.indexOf(item._id) === -1
                    })

                    self.selectBucket.push({
                        _id: self.subjectPackage[i]._id,
                        list: subject,
                        name: self.subjectPackage[i].name,
                        type: self.subjectPackage[i].type
                    })
                } else {
                    self.selectBucket.push({
                        _id: self.subjectPackage[i]._id,
                        list: [],
                        name: self.subjectPackage[i].name,
                        type: self.subjectPackage[i].type
                    })
                }

            }
            let finalObj = {}

        }

        // this.$onInit = function() {
        //     console.log(this)
        //     $scope.cirriculumId = this.cirriculumId;
        //     $scope.sessionId = this.sessionId;
        //     $scope.acdConsoles = this.acdConsoles;
        //     $scope.sett = this.sett;
        //     setSubjects()
        // }
        
        this.$onChanges = function() {
            $scope.cirriculumId = this.cirriculumId;
            $scope.sessionId = this.sessionId;
            $scope.acdConsoles = this.acdConsoles;
            $scope.sett = this.sett;
            setSubjects()
        }

        // self.selectedCurriculum = [];
        // self.allSubjectsList = []
        // let newDataArry = {};
        // let upSetArry = {};
        // this.packagesToAdd = []
        // let curriculumArry = [];
        // let sessionsArry = [];
        // let sessionsChk = [];
        // self.enableNextBtn = false;
        // self.enableNewSubjectBtn = false;
        // self.enableNewSubjectDiv = false;


        

        self.collapseRight = (fileData, index) => {

            for (var j = 0; j < self.selectBucket.length; j++) {
                if (j != index) {
                    self.packagesToAdd[j].expanded = false;
                    self.selectBucket[j].expanded = false;
                }
            }
            if (!fileData.expanded) {
                self.selectBucket[index].expanded = true;
                self.packagesToAdd[index].expanded = true;
            } else {
                self.selectBucket[index].expanded = false;
                self.packagesToAdd[index].expanded = false;
            }

        }

        self.collapseBucket = (data, index) => {

            for (var i = 0; i < self.packagesToAdd.length; i++) {
                if (i != index) {
                    self.packagesToAdd[i].expanded = false;
                    self.selectBucket[i].expanded = false;
                }
            }
            if (!data.expanded) {
                self.selectBucket[index].expanded = true;
                self.packagesToAdd[index].expanded = true;
            } else {
                self.selectBucket[index].expanded = false;
                self.packagesToAdd[index].expanded = false;
            }

        }

        self.clickRightBucketItems = function(index) {
            let data = _.filter($scope.sett, function(one){
                return one.type == "subject"
            })
            self.packagesToAdd[index].list = _.clone(self.selectBucket[index].list);
            self.selectBucket[index].list = [];
            self.collapseBucket(self.selectBucket[index], index)
            toastr.success("Subjects Removed from bucket");
        }

        self.clickLeftBucketItems = function(index) {


            let data = _.filter($scope.sett, function(one){
                return one.type == "subject"
            })

            self.collapseRight(self.packagesToAdd[index], index)
            self.selectBucket[index].list = data[index].list;
            self.packagesToAdd[index].list = [];
            toastr.success("Subjects Added to bucket");
        }


        self.saveSubjectArry = function() {
            self.enableNextBtn = false;
            self.updateAcademicConsole($scope.sessionId, $scope.cirriculumId)
        }

        self.updateAcademicConsole = function(sessId, curiId) {

            if (!self.selectBucket || self.selectBucket.length === 0) {
                toastr.error("Please add some subjects.");

            }

            let toContinue = 0

            _.each(self.selectBucket, function(pack) {
                if (!pack.list || pack.list.length === 0) {
                    toContinue += 1
                }
            })

            if (toContinue === self.selectBucket.length) {
                toastr.error("Empty subject package not allowed.");
                return false
            }
            
            let reqObj = {
                session_id: sessId,
                curriculum_id: curiId,
                subject_packages: self.selectBucket,
                school_id: localStorageService.get('school_id')
            }

            authService.callAPI("/v0/initial-settings/updateSubjectPackage", "POST", reqObj, function (response) {
                try {
                    if (response.error)
                        toastr.error("Please try after some time.");
                    else 
                        toastr.success("Subject package added successfully!");
                } catch(e) {
                    console.log(e)
                }
            })
        }

        self.dragControlListeners = {
            containment: '#blocks'

        }

        self.sortableCloneOptions1 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            dragEnd: function() {
                self.enableNewSubjectDiv = false
                    // setSubjects()
            }
        }

        // self.getSubjectPackages();

    }
}


export default angular.module(name, [
        // angularMeteor,
        // uiRouter,
        'wizardStatus'
    ])
    .component("academicConsole", {
        template: academicConsole,
        controllerAs: 'setClassSliderCtrl',
        controller: ['$scope',  '$stateParams', '$rootScope', '$state', 
        '$mdDialog', '$mdMedia','localStorageService', 'authService', AcademicConsoleCtrl]
    })
    .component("addSubject", {
        template: subjectTemplate,
        controllerAs: 'addSubjectCtrl',
        bindings: {
            cirriculumId: '<',
            sessionId: '<',
            acdConsoles : '<',
            sett : '<'
        },
        controller: ['$scope',  '$stateParams', '$rootScope', 
        '$state', '$mdDialog', '$mdMedia','localStorageService', 'authService', AddSubject]
    })
    .controller('academicConsole', AcademicConsoleCtrl);


function config($stateProvider) {
    'ngInject';
    $stateProvider.state('academicConsole', {
        url: '/academicConsole',
        template: '<academic-console></academic-console>'
    });
}


// WEBPACK FOOTER //
// ./src/app/initial_settings/academicconsoleModule.js